import React from 'react';
import { Box, Divider } from '@material-ui/core';
export const Line = ({ margin = '0' }) => {
    return (
        <Box my={margin}>
            <Divider />
        </Box>
    );
}